module.exports = __webpack_public_path__ + "img/tutorial-f05-01.d0208d10.png";